import { GoogleMapsConstants } from '../app/core/constants/maps-constants';

export const environment = {
    production: false,
    apiUrl: 'https://preprodcoordinationappservice-f5bhc4dkcuegbzbd.eastus-01.azurewebsites.net',
    logoutReturnTo: 'https://pre-prod-cevo.enterprisewireless.org',
    registrationCompleteLogoutReturnTo:
        'https://pre-prod-cevo.enterprisewireless.org/registration-complete',
    ewaWebsiteUrl: 'https://test-ewa-backdrop.pantheonsite.io',
    googleMapsApiKey: GoogleMapsConstants.API_KEY,
    googleMapsMapId: GoogleMapsConstants.MAP_ID,
    auth0: {
        domain: 'pre-prod.security.enterprisewireless.org',
        clientId: 'zZoNribTwmzHgy9h50ehbA4Ptewtwfsd',
        authorizationParams: {
            redirect_uri: 'https://pre-prod-cevo.enterprisewireless.org',
        },
    },
};
